import {
  Initial,
  ITrackingProperties,
  LodgingOffersEvents,
  PremierCollectionEntryProperties,
} from "redmond";
import { put } from "redux-saga/effects";
import { trackEvent } from "../../../api/v0/analytics/trackEvent";
import { fetchPremiumCollectionOffersAvailability } from "../../../api/v0/offers/fetchPremiumCollectionOffersAvailability";
import { actions } from "../actions";
import { RequestStateUtils } from "../reducer";
import { transformToStringifiedQuery } from "../utils/queryStringHelpers";

export default function* fetchPremiumOffersShopSaga(
  action: actions.IFetchPremiumOffersShop
) {
  try {
    if (JSON.stringify(action.params) === "{}") return;

    // Update URL immediately with search parameters
    const shopParams = transformToStringifiedQuery({
      fromDate: action.params.stayDates.from,
      untilDate: action.params.stayDates.until,
      adultsCount: action.params.guests.adults,
      children: action.params.guests.children,
    });

    action.history.replace({
      pathname: action.history.location.pathname,
      search: shopParams,
    });

    const response: Initial = yield fetchPremiumCollectionOffersAvailability(
      action.params
    );

    yield put(
      actions.setPremiumOffersShopResults(
        RequestStateUtils.success(action.params, response)
      )
    );

    // TODO: CLUX-641 - proper tracking properties
    const properties: ITrackingProperties<PremierCollectionEntryProperties> = {
      properties: {
        delegated_to: "",
        first_launch: false,
        market: "",
        country: "",
        number_of_properties: 0,
        number_of_guests: 0,
        hotel_advance: "",
        rooms_searched: 0,
        has_credits: false,
        credit_balance: 0,
        vx_statement_credit_balance: 0,
      },
      encryptedProperties: [],
    };
    //   yield select(getPremierCollectionEntryProperties);

    trackEvent({
      eventName: action.params.lodgingCollection
        ? LodgingOffersEvents.PC_OFFERS_ENTRY
        : LodgingOffersEvents.LC_OFFERS_ENTRY,
      properties,
    });
  } catch (e) {
    // TODO: CLUX-627 - Need any specific error handling?
    yield put(
      actions.setPremiumOffersShopResults(
        RequestStateUtils.failed(action.params, e)
      )
    );
  }
}
